import { useLoginStates } from '@/hooks';

export const useDocumentsUploadCopies = () => {
  const { isLoggedIn } = useLoginStates();

  return isLoggedIn
    ? {
        headline: 'JOBS_POSTING_XING_APPLY_UPLOAD_HEADLINE',
        body: 'JOBS_INSTANT_APPLY_UPLOAD_BODY',
        filesHint: 'JOBS_INSTANT_APPLY_UPLOAD_HINT_FILES',
        formatHint: 'JOBS_INSTANT_APPLY_UPLOAD_HINT_FORMAT',
        uploadCvButton: 'JOBS_INSTANT_APPLY_UPLOAD_CV_BUTTON',
        uploadOtherDocumentsButton: 'JOBS_INSTANT_APPLY_UPLOAD_OTHER_BUTTON',
      }
    : {
        headline: 'JOBS_POSTING_XING_APPLY_UPLOAD_HEADLINE_LO',
        body: 'JOBS_POSTING_XING_APPLY_UPLOAD_BODY_LO',
        filesHint: 'JOBS_POSTING_XING_APPLY_UPLOAD_HINT_LO_FILES',
        formatHint: 'JOBS_POSTING_XING_APPLY_UPLOAD_HINT_LO_FORMAT',
        uploadCvButton: 'JOBS_POSTING_XING_APPLY_UPLOAD_CV_BUTTON_LO',
        uploadOtherDocumentsButton: 'JOBS_POSTING_XING_APPLY_UPLOAD_OTHER_BUTTON_LO',
      };
};
